import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export default function useGetTodos() {
  const fetchData = async () => {
    const response = await httpClient.get(`team/cash-flow/to-do`)
    return response.data.data
  }

  return useQuery({
    queryKey: ['todos', 'list'],
    queryFn: fetchData,
  })
}
